import { useAppContext } from 'contexts/app-context/hooks/useAppContext'

import { useQuery } from '@tanstack/react-query'

import { getPurposesUsQueryOptions } from './queries/getPurposesUsQueryOptions'

export const useGetPurposesUs = (productId?: string) => {
  const { privacyCenterContent, userSelectedEntity, userAccountType, isUSBranch, userCountry } =
    useAppContext()

  const endpoint = privacyCenterContent?.endpoints?.preferences?.getPreferencesUs

  const {
    data,
    status: purposesStatus,
    isError: isPurposesError,
  } = useQuery(
    getPurposesUsQueryOptions({
      endpoint,
      userCountry,
      userSelectedEntity,
      userAccountType,
      productId,
      isUSBranch,
    }),
  )

  const purpose = data?.preferences

  return {
    purpose,
    purposesStatus,
    isPurposesError,
    isPurposesLoading: purposesStatus === 'pending',
  }
}
